import React from "react";
import { useRacketLabAdminT } from "@/i18n/racketLabAdminI18n";

/**
 * RLShopServiceModeBadge — RACKET-LAB-ROLE-5 (Feb 2026).
 *
 * Reusable visual badge for `racket_lab_shops.settings.service_mode`.
 * Uses ONLY existing values (`in_shop` | `mobile` | `hybrid`); unknown
 * / missing values render as a neutral "—" badge.
 *
 * Internal-only. No customer-facing styling, no copy that leaks to the
 * public surface.
 */
const PALETTE = {
  in_shop: { bg: "bg-emerald-100", text: "text-emerald-800" },
  mobile: { bg: "bg-sky-100", text: "text-sky-800" },
  hybrid: { bg: "bg-amber-100", text: "text-amber-900" },
};

const RLShopServiceModeBadge = ({ mode, size = "sm" }) => {
  const t = useRacketLabAdminT();
  const palette = PALETTE[mode] || { bg: "bg-slate-100", text: "text-slate-600" };
  const label = mode ? t(`shops.service_mode.${mode}`) : "—";
  const sizeCls = size === "xs"
    ? "px-1.5 py-0.5 text-[9px]"
    : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`rl-shop-service-mode-badge-${mode || "unknown"}`}
      className={`inline-flex items-center gap-1 rounded-full font-medium ${palette.bg} ${palette.text} ${sizeCls}`}
      title={t("shops.service_mode.tooltip")}
    >
      {label}
    </span>
  );
};

export default RLShopServiceModeBadge;
